import React from "react";
import { Box, styled, Typography } from "@mui/material";

export const TableWrapper = styled("div")(() => ({
  marginTop: "15px",
}));

interface ISectionTitleProps {
  title: string;
  children: React.ReactNode;
}
export const SectionTitle: React.FC<ISectionTitleProps> = ({ title, children }) => (
  <Box mt="15px">
    <Typography fontWeight="bold" mb="5px">
      {title}
    </Typography>
    <Box>{children}</Box>
  </Box>
);
